import { Grid } from "@mui/material";
import { DataType, EffectSearch } from "components/EffectSearch/EffectSearch";
import { prepareSchemaConditionForAutocompleteVariables } from "components/Layout/Campaign/Common/CampaignRules/rulesHelpers";
import { useMessage } from "hooks/intl";
import { SelectedSchemaCondition } from "types/campaigns";
import { templateItems } from "./templates";

export function GivePointsEventBased({
  fieldName,
  selectedSchemaConditions,
}: {
  fieldName: string;
  selectedSchemaConditions: SelectedSchemaCondition[];
}) {
  const { message } = useMessage();

  const data: DataType[] = [
    { name: "templates", items: templateItems },
    {
      name: "variables",
      items: prepareSchemaConditionForAutocompleteVariables(
        selectedSchemaConditions,
      ),
    },
  ];

  return (
    <Grid item xs={12}>
      <EffectSearch
        data-test-id="give-points-event-based"
        items={data}
        name={fieldName}
        placeholder={message({ id: "autocompletePlaceholder" })}
      />
    </Grid>
  );
}
